import { Controller } from '@hotwired/stimulus'

import { DispatchEvent } from '../types'

interface Organization {
  erp_id: string
  id: string
  name: string
  url: string
}

export class UsageEventOrganizationController extends Controller {
  static targets = ['erpId', 'erpIdContainer', 'name']

  declare readonly erpIdTarget: HTMLElement
  declare readonly erpIdContainerTarget: HTMLElement
  declare readonly nameTarget: HTMLElement

  update(event: DispatchEvent<{ detail: Organization }>) {
    const { erp_id, id, name, url } = event.detail

    if (erp_id) {
      this.erpIdContainerTarget.classList.remove('hidden')
    } else {
      this.erpIdContainerTarget.classList.add('hidden')
    }
    this.erpIdTarget.textContent = erp_id

    if (name) {
      this.element.classList.remove('hidden')
    } else {
      this.element.classList.add('hidden')
    }
    const link = document.createElement('a')
    link.textContent = name
    link.href = url
    this.nameTarget.replaceChildren(link)
  }
}
